import { memo } from "react";

function XdaLabelSpacing_Icon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M16.5 4C16.8148 4 17.111 4.14858 17.2998 4.40039L22.5498 11.4004C22.8163 11.7559 22.8163 12.2441 22.5498 12.5996L17.2998 19.5996C17.111 19.8514 16.8148 20 16.5 20H13.501C13.822 19.2303 14 18.386 14 17.5C14 13.9101 11.0899 11 7.5 11C5.18309 11 3.15101 12.2133 2 14.0381V5C2 4.44772 2.44772 4 3 4H16.5Z"
        fill="currentColor"
      />
      <path
        d="M7.50195 12.2959L9.62402 14.417L8.91602 15.124L8 14.208V17H10.7676L9.88281 16.1152L10.5898 15.4082L12.7119 17.5303L10.5898 19.6523L9.88281 18.9453L10.8281 18H8V20.7979L8.91602 19.8818L9.62402 20.5889L7.50195 22.71L7.50098 22.7109L5.37988 20.5898L6.08691 19.8818L7 20.7949V18H4.17578L5.12109 18.9453L4.41406 19.6523L2.29199 17.5303L4.41406 15.4082L5.12109 16.1152L4.23633 17H7V14.21L6.08691 15.123L5.37988 14.416L7.50098 12.2949L7.50195 12.2959Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default memo(XdaLabelSpacing_Icon);
